import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FundShareTakeAction.css'
import config from '../../config'
import analytics from '../../helpers/analytics'
import { Link,
         LinkIcon,
         SocialButtons,
         MorningstarLink,
         AboutBanner,
         Returns } from '../'
// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FundShareTakeAction extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    shareClass: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    screen: PropTypes.string
  }
  constructor(props){
    super(props);
  }

  renderMorningstarLink = (shareClass) => {
    return (
      <MorningstarLink url={shareClass.morningstar_url} ticker={shareClass.ticker}/>
    )
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>{info}</div>
          <div styleName='take-action-button-wrap'>
            <Link
              to={link}
              log={log}
              title={button}>
              <div styleName='take-action-button'>
                {button}<LinkIcon/>
              </div>
            </Link>
          </div>
        </div>
      )
    }

    return (
      <div styleName='take-action-wrap'>
        <div styleName='take-action-anchor' id='take-action'/>
        <div styleName='take-action'>
          <div styleName='take-action-inner'>

            {renderAction( 'Ask your employer about adding gun free options to your retirement plan',
            'Use our toolkit', config.routes.toolkit, analytics.eventToToolkit() )}

            {renderAction( 'Find sustainable funds that are gun free',
            'Find clean funds', config.routes.clean )}

            {renderAction( 'Visit Weapon Free Funds to see this fund\'s exposure to military weapon companies',
            'See weapon risk',
            config.links.wffFund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id,
            analytics.eventToWFF(shareClass.fund_id,shareClass.investment_vehicle_id) )}

            {renderAction( 'Visit Fossil Free Funds to see this fund\'s exposure to fossil fuel companies and companies with high carbon footprints',
            'See climate risk',
            config.links.fffFund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id,
            analytics.eventToFFF(shareClass.fund_id,shareClass.investment_vehicle_id) )}

          </div>
        </div>
      </div>
    )
  }

  render() {
    const { shareClass, fund, url } = this.props

    return (
      <div>

        { /*
        <Returns
          fund={fund}
          shareClass={shareClass}
          url={url}
        />
        */ }

        { /*
        <div styleName='holdings-count'>
          <div styleName='holdings-count-wrap'>
            <div styleName='holdings-count-social'>
              <div styleName='holdings-count-headline'>
                What's next?
              </div>
              <div styleName='holdings-count-intro'>
                Learn how to make a change and move your money
              </div>
              <div styleName='holdings-count-intro'>
                Get started with our action toolkit
              </div>
              <Link
                to={config.routes.toolkit}
                title='Action toolkit'>
                <div styleName='holdings-count-button'>
                  Action toolkit<LinkIcon/>
                </div>
              </Link>
            </div>
            <div styleName='holdings-count-morningstar'>
              { this.renderMorningstarLink(shareClass) }
            </div>

          </div>

          <SocialButtons
            message={config.app.title+' - '+shareClass.fund_legal_name}
            link={this.props.url}
          /> 

        </div>
        */ }

        { this.renderTakeAction(shareClass) }

        <div styleName='banner'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}